import { render, staticRenderFns } from "./OMenuMobileComp.vue?vue&type=template&id=d66ef194&"
import script from "./OMenuMobileComp.vue?vue&type=script&lang=js&"
export * from "./OMenuMobileComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports